import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import Wordmark from "@/components/Wordmark";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const token = sp.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated · you're signed in.");
      window.location.href = "/";
    } catch (e2) {
      setErr(typeof e2?.response?.data?.detail === "string" ? e2.response.data.detail : "Could not reset the password.");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-5" data-testid="reset-password-page">
      <div className="w-full max-w-sm">
        <Wordmark size="text-2xl" logoClass="w-7 h-7" />
        <h1 className="font-heading text-2xl font-black tracking-tight mt-8">Set a new password</h1>
        {!token ? (
          <p className="text-sm text-muted-foreground mt-4">
            This link is missing its token. Request a new reset link from the sign-in page.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-3 text-muted-foreground" />
              <input data-testid="reset-password-input" type="password" required minLength={8} value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" className="inp pl-9" />
            </div>
            {err && <p data-testid="reset-error" className="text-xs text-traffic-red">{err}</p>}
            <button data-testid="reset-submit" type="submit" disabled={busy}
              className="w-full bg-foreground text-background font-medium py-3 flex items-center justify-center gap-2 disabled:opacity-30">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} Update password
            </button>
          </form>
        )}
        <button onClick={() => navigate("/login")} className="mt-4 text-xs text-muted-foreground hover:text-foreground">Back to sign in</button>
      </div>
    </div>
  );
}
